import React, { ReactNode } from 'react'

import Link from '@atoms/Link'

import * as style from './style.module.sass'

type ExpandingImageLinkProps = {
  children: ReactNode
  to: string
  isSlow?: boolean
}

const ExpandingImageLink: React.FC<ExpandingImageLinkProps> = ({
  children,
  to,
  isSlow = false,
}) => (
  <Link to={to} className={style.link} data-slow={isSlow}>
    {children}
  </Link>
)

export default ExpandingImageLink
